import React from "react";
import { MotionConfig } from "framer-motion";
import { StatusStrip } from "./components/layout/StatusStrip";
import { SiteHeader } from "./components/layout/SiteHeader";
import { SiteFooter } from "./components/layout/SiteFooter";
import { MobileOfferBar } from "./components/layout/MobileOfferBar";
import { Hero } from "./components/sections/Hero";
import { StatStrip } from "./components/sections/StatStrip";
import { OpenLookTeach } from "./components/sections/OpenLookTeach";
import { UnitSection } from "./components/sections/UnitSection";
import { RouteSection } from "./components/sections/RouteSection";
import { SessionSection } from "./components/sections/SessionSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { FaqSection } from "./components/sections/FaqSection";
export function App() {
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="23ujk0b9f7l2z">
      <div className="min-h-screen w-full bg-navy font-body text-ice" data-id="element-1" data-mp="23ti7e2craqj5">
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-[8px] focus:bg-orange focus:px-5 focus:py-3 focus:text-white" data-id="element-2" data-mp="3ijfunyhrpue3">
          Skip to content
        </a>
        <StatusStrip data-id="element-3" data-mp="6hqffdy0fe4" />
        <SiteHeader data-id="element-4" data-mp="4wx1t3d72hu" />
        <main id="main" tabIndex={-1} className="outline-none" data-id="element-5" data-mp="5gbv0xpxarn">
          <Hero data-id="element-6" data-mp="2zlv84y2h77wn" />
          <StatStrip data-id="element-7" data-mp="2zmeoiach9o8k" />
          <OpenLookTeach data-id="element-8" data-mp="2zmwh8wzxlkbq" />
          <UnitSection data-id="element-9" data-mp="33movnqc0akp0" />
          <RouteSection data-id="element-10" data-mp="33lwy49yumcw3" />
          <SessionSection data-id="element-11" data-mp="33nghwajpr62m" />
          <BonusesSection data-id="element-12" data-mp="33ork45xig5rm" />
          <OfferSection data-id="element-13" data-mp="38m1fe27kzbnd" />
          <FaqSection data-id="element-14" data-mp="38kqce4lym7xb" />
        </main>
        <SiteFooter data-id="element-15" data-mp="38nunzn1r85y0" />
        <MobileOfferBar data-id="element-16" data-mp="3dkuwe4m2tksa" />
      </div>
    </MotionConfig>;
}